/**
 *
 * @param {object} props
 * @param {string} props.label
 * @returns
 */
export function Labelled({label, children, ...props}) {
  return <div className="flex flex-col" {...props}>
    <div className="text-toda-gray text-sm font-medium">{label}</div>
    {children}
  </div>
}

export function Editable({ isEditing, children, ...props }) {
  if (isEditing) {
    return <input className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400  invalid:text-error"
      defaultValue={children}
      {...props} />;
  } else {
    return <div className="w-full py-1">
      {children}
    </div>;
  }
}

export function Enumerable({ isEditing, children, options, ...props }) {
  if (isEditing) {
    return <select
      className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400"
      defaultValue={children}
      {...props}>
      {options.map(o => <option key={o} value={o}>{o}</option>)}
    </select>;
  } else {
    return <div className="w-full py-1">
      {children}
    </div>
  }
}